export default __webpack_public_path__ + "static/media/AUTORES_DISCO_04.c14c9712.png";